export default "__VITE_ASSET__b6a36c0b__"